<div class="copyright-bottom">
    <span><span>Relay Navigator</span><span class="footer-left">©2022 Verisk Analytics Inc.</span></span>
  </div>